import { render } from "./intermedio.vue?vue&type=template&id=2dda9427&scoped=true"
import script from "./intermedio.vue?vue&type=script&lang=js"
export * from "./intermedio.vue?vue&type=script&lang=js"

import "./intermedio.vue?vue&type=style&index=0&id=2dda9427&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dda9427"]])

export default __exports__